export const platformConf = [
  {
    label: '蚂蚁',
    value: 'my',
    platform: 'my',
    host: 'https://admin-api.sdk.mayigames.com/'
  },
  {
    label: '水熊',
    value: 'sx',
    platform: 'sx',
    host: 'http://admin-api.sdk.beargames.cn/'
  },
  {
    label: '机暴',
    value: 'jb',
    host: 'https://jb-admin-api.sdk.rotifer.cn/'
  },
  {
    label: '宏狐',
    value: 'fox',
    host: 'http://fox-admin-api.sdk.mayigames.com/'
  },
  {
    label: '轮虫',
    value: 'lc',
    host: 'https://admin-api.sdk.rotifer.cn/'
  },
  {
    label: '测试',
    value: 'test',
    host: 'http://admin-api.sdk.dev.mayigames.com/'
  },
]